import { render, staticRenderFns } from "./ArticleListWidget.vue?vue&type=template&id=03ab3823"
import script from "./ArticleListWidget.vue?vue&type=script&lang=js"
export * from "./ArticleListWidget.vue?vue&type=script&lang=js"
import style0 from "./ArticleListWidget.vue?vue&type=style&index=0&id=03ab3823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports